import {
  type NotificationMessage,
  NotificationVariant,
} from './../store/notification.types';
import { computed } from 'vue';
import { useNotificationStore } from '../store/notification.store';

export function useNotification() {
  const notificationStore = useNotificationStore();

  const getLastNotification = computed(() => {
    const notifications = notificationStore.notifications;
    const allNotifications = Object.values(notifications);

    // First, try to get the most recent ERROR notification
    const errorNotifications = allNotifications.filter(
      (notification) => notification.variant === NotificationVariant.ERROR,
    );

    if (errorNotifications.length > 0) {
      return errorNotifications[errorNotifications.length - 1];
    }

    // If no ERROR notifications, return the most recent notification overall
    return allNotifications.pop();
  });

  const addNotification = (payload: NotificationMessage) => {
    notificationStore.addNotification(payload);
  };

  const removeNotification = (key: string) => {
    notificationStore.removeNotification(key);
  };

  return {
    getLastNotification,
    addNotification,
    removeNotification,
  };
}
